import CallAnalysis from './CallAnalysis';

export default CallAnalysis;
